import React from "react";

import './FieldsetContainer.scss';

const FieldsetContainer = ({children, title, noBorder}) =>
{
    return (
        <fieldset className="scheduler-border">
            <legend className="scheduler-border">{title}</legend>
            <div className="control-group">
                { children }
            </div>
        </fieldset>
    )
}

export default FieldsetContainer ;